<template>
  <div class="main-menu">
    <DesktopMenu />
  </div>
</template>
<script>
import DesktopMenu from "@/components/Header/Navtools/DesktopMenu.vue";
export default {
  components: {
    DesktopMenu,
  },
};
</script>
<style lang=""></style>
